import request from 'superagent';
const ROOT_URL = process.env.API_URL;
const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const asyncValidate = (values, dispatch, props, field) => {

    if (field === 'winecellar_area_code') {
        return request('GET', ROOT_URL + '/area_codes/_code/' + values.winecellar_area_code).then(function(result) {

        }, function(err) {
            throw { winecellar_area_code: 'El código de área no es válido.', _error: 'Revisá los campos indicados.'}
        });
    }

    if (field === 'winecellar_number') {
        if (values.winecellar_area_code && values.winecellar_number) {
            return request('GET', ROOT_URL + '/subscribers/_check/' + values.winecellar_area_code + values.winecellar_number).then(function(result) {
            }, function(err) {
                throw { winecellar_number: 'El número no es válido.', _error: 'Revisá los campos indicados.'}
            });
        }
    }
    return sleep(1);
}

export default asyncValidate



/** WEBPACK FOOTER **
 ** ./src/components/Validations/asyncValidationsWinecellarForm.js
 **/